"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.KeyCode = void 0;
var KeyCode = exports.KeyCode = {
  Up: 38,
  Down: 40,
  Space: 32,
  Enter: 13,
  Esc: 27,
  Backspace: 8,
  Tab: 9
};